import { render, staticRenderFns } from "./mySellers.vue?vue&type=template&id=012171da&scoped=true&lang=html&"
import script from "./mySellers.vue?vue&type=script&lang=js&"
export * from "./mySellers.vue?vue&type=script&lang=js&"
import style0 from "./mySellers.vue?vue&type=style&index=0&id=012171da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012171da",
  null
  
)

export default component.exports